import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="w-screen h-screen bg-whiteColor flex flex-col justify-center items-center space-y-[2%]">
      <span className="font-bold text-[3vw] text-primaryColor">
        Page Not Found
      </span>
      <p className="font-semibold text-[1.25vw] text-textPrimaryColor">
        Redirecting to homepage...
      </p>
    </div>
  );
};

export default PageNotFound;
